
import { defineComponent, PropType } from "vue";
import { TEvent } from "@/Types";

export default defineComponent({
  name: "EventCard",
  props: {
    event: {
      type: Object as PropType<TEvent>,
      required: true,
    },
  },
});
